/*@flow*/
import useField from './useField';
import useItems from './useItems';
import { isInnerTypeList, getNullOption } from '../util';
import type { PathT } from '../types';

export default function useSelectItems(path: PathT): any | Array<{text: string, value: any, ...}> {
  const { fieldOptions, typeInfo } = useField(path);
  const isMultiple = isInnerTypeList(typeInfo);
  const items = useItems(path);

  const nullOption = getNullOption(fieldOptions);
  if (!isMultiple && fieldOptions.nullOption !== false) {
    items.unshift(nullOption);
  }

  return items;
}
